import { routes } from './lib/routes';
export default routes;
